import { Badge, Tooltip } from '@mantine/core';
import { useNetwork } from '@mantine/hooks';
import { useSyncStatus } from '../app/services';
import { Copy } from './Brand';

const ago = (ms: number) => {
  const s = Math.round((Date.now() - ms) / 1000);
  return s < 60 ? 'just now' : s < 3600 ? `${Math.round(s / 60)} min ago` : new Date(ms).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

/** Saved and synced? Everything is always saved on this device first; sync copies it to the account. */
export const StatusPill = () => {
  const { online } = useNetwork();
  const sync = useSyncStatus();
  const s = sync?.status;
  const waiting = s && s.pending > 0 ? ` · ${s.pending} waiting` : '';
  const [label, color, tip] =
    !s || s.state === 'off'
      ? [online ? 'Saved' : 'Offline · saved', online ? 'green' : 'gray', `Saved on this device.${s?.message ? ` ${s.message}` : ''}`]
      : s.state === 'syncing'
        ? ['Syncing', 'blue', 'Saved on this device. Syncing with your account…']
        : s.state === 'offline' || !online
          ? [`Offline${waiting}`, 'gray', `Offline. Everything is saved on this device${s.pending ? ` and ${s.pending} change${s.pending === 1 ? '' : 's'} will sync when you're back online` : ''}.`]
          : s.state === 'error'
            ? [`Sync paused${waiting}`, 'yellow', `Saved on this device. ${s.message ?? ''}`]
            : [s.pending ? `Saved${waiting}` : 'Synced', 'green', `Saved on this device${s.lastSyncAt ? ` and synced ${ago(s.lastSyncAt)}` : ''}.`];
  return (
    <Tooltip label={<Copy>{tip}</Copy>} multiline w={260}>
      <Badge variant="dot" color={color} size="sm" data-testid="status-pill" data-sync={s?.state ?? 'none'}>
        {label}
      </Badge>
    </Tooltip>
  );
};
